import { render, staticRenderFns } from "./section.vue?vue&type=template&id=773f2d03&scoped=true"
import script from "./section.vue?vue&type=script&lang=js"
export * from "./section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f2d03",
  null
  
)

export default component.exports